import React, { useEffect, useState } from "react";

// REDUX
// ROUTES
import { setPageTitleState } from "../utils/routes";
import { useLocation } from "react-router-dom";
// APP
import DesktopMenu from "./menuBar/DesktopMenu";
import MobileMenu from "./menuBar/MobileMenu";
// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import AdbIcon from "@mui/icons-material/Adb";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import { COLLAPSED_DRAWER_WIDTH } from "../types/constants";

function ResponsiveAppBar(props) {
  const location = useLocation();

  const [anchorElNav, setAnchorElNav] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(null);

  useEffect(() => {
    setPageTitleState(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    setIsLoggedIn(props.isLoggedIn);
  }, [props.isLoggedIn]);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const renderMobileAppBar = () => {
    return (
      <AppBar
        position="fixed"
        elevation={2}
        sx={{
          bottom: 0,
          top: "auto",
          minHeight: "46px !important",
          maxHeight: "46px !important",
          backgroundColor: "#fff",
          display: { xs: "block", md: "none" },
        }}
      >
        <Container maxWidth="xl">
          <Toolbar
            disableGutters
            sx={{
              minHeight: "56px !important",
              maxHeight: "56px !important",
            }}
          >
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="primary"
              >
                <MenuIcon />
              </IconButton>

              {isLoggedIn && (
                <MobileMenu
                  anchorEl={anchorElNav}
                  open={Boolean(anchorElNav)}
                  onClose={handleCloseNavMenu}
                  handleRestaurants={props.handleRestaurants}
                  logout={props.logout}
                  userType={props.userType}
                />
              )}
            </Box>
            <AdbIcon sx={{ display: { xs: "flex", md: "none" }, mr: 1 }} />
          </Toolbar>
        </Container>
      </AppBar>
    );
  };

  const renderDesktopMenu = () => {
    if (!isLoggedIn) {
      return null;
    }

    return (
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <DesktopMenu
          handleRestaurants={props.handleRestaurants}
          logout={props.logout}
        />
        <Box sx={{ mr: `${COLLAPSED_DRAWER_WIDTH}px` }} />
      </Box>
    );
  };

  return (
    <>
      {renderMobileAppBar()}
      {renderDesktopMenu()}
    </>
  );
}

export default ResponsiveAppBar;
